import connection from './connection.js'

const userRole = async function (callback) {
  const url = '/user/role'
  let { error, data } = await connection.query(url)
  if (callback) callback(error, data)
}

const passwordChange = async function (params, callback) {
  const url = 'admin/manager/password/update'
  let { error, data } = await connection.update(url, params)
  if (callback) callback(error, data)
}

export default {
  userRole: userRole,
  passwordChange: passwordChange,
}
